import type { BuilderType } from '@shared/utils/api/configs/rtkBaseQueryDemo';
import { GET_USER_PROFILE_BASIC_SECURE_URL, GET_USER_PROFILE_BASIC_URL } from '@shared/utils/api/configs/URL';
import { hasCcdpSuccess } from '@shared/utils/api/handlers/interpretCcdpCode/interpretCcdpCode';
import type { GenericApiResponse } from '@shared/utils/api/types';

import type { GetProfileBasicPayload, GetProfileBasicResult } from '../types/getProfileBasic.types';

export const PROFILE_BASIC_TAGS = 'getProfileBasic';

export const getProfileBasic = (builder: BuilderType) =>
  builder.query<GetProfileBasicResult, GetProfileBasicPayload>({
    query: ({ secure, ...data }) => ({
      data,
      method: 'POST',
      url: secure ? GET_USER_PROFILE_BASIC_SECURE_URL : GET_USER_PROFILE_BASIC_URL,
    }),
    providesTags: [PROFILE_BASIC_TAGS],
    transformResponse: (response: GenericApiResponse<GetProfileBasicResult>) => {
      if (hasCcdpSuccess(response)) {
        return response.Result;
      }

      throw {
        code: response.Code,
        message: response.Message,
      };
    },
  });
